// CASE_2810 (GROK2 28/10): só exibição — Title Case com siglas preservadas. Não altera dados salvos.
const SIGLAS = new Set(['IPTV', 'XP', 'MN', 'TECH', 'XCIPTV', 'UTRA', 'M3U', 'TV', 'P2P', 'HD', 'FHD', '4K']);
const MENORES = new Set(['de', 'da', 'do', 'das', 'dos', 'e', 'com', 'sem']);
export function titleCase2810(s) {
  return String(s || '').trim().split(/(\s+|\/|\(|\)|-)/).map((w, i) => {
    if (!w || /^[\s/()-]+$/.test(w)) return w;
    const up = w.toUpperCase();
    if (SIGLAS.has(up)) return up;
    if (/\d/.test(w) && !/^\d+$/.test(w) && w.length <= 3) return up;
    const lo = w.toLocaleLowerCase('pt-BR');
    if (i > 0 && MENORES.has(lo)) return lo;
    return lo.charAt(0).toLocaleUpperCase('pt-BR') + lo.slice(1);
  }).join('');
}
export function planName2810(p) {
  return titleCase2810(String(p?.label || p?.name || '').replace(/^\s*plano\s+/i, ''));
}
